import queryString from "query-string";

export const retrieveParamsFromUrl = (url) => {
  return queryString.parse(url);
};

export default {
  retrieveParamsFromUrl,
};
